module.exports = __webpack_public_path__ + "media/images/welcome/main_visual_sp-598eb888ecb45a44a1006eed195347e5.png";